import _ from 'lodash'
import axios from 'axios'
import firebase from 'firebase/app'

axios.defaults.baseURL =
  process.env.REACT_APP_ENV === 'local'
    ? 'http://localhost:5900/evergreen-350bb/us-central1/api'
    : 'https://us-central1-evergreen-350bb.cloudfunctions.net/api'

let api = async (url, params, config = {}) => {
  try {
    let token = await firebase.auth().currentUser.getIdToken()
    let { data, status } = await axios.post(
      url,
      params,
      _.merge({}, config, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    )

    if (status !== 200) {
      throw new Error('error with request')
    }

    return data
  } catch (err) {
    console.log(
      `There was an error calling ${url} with these params`,
      params,
      err
    )

    throw err
  }
}

window.api = api
export default api
